/* eslint-disable prettier/prettier */
import { Box } from '@mui/system';
import React from 'react';
import QueueCard from '.';

const ThreadCard = ({ id, texts, len, dateTimeMS, status, setTriggerQueueFetch }) => {
    const a = 1;
    return (
        <Box
            sx={{
                my: 5
            }}
        >
            <Box
                sx={{
                    borderLeft: '1px solid gray',
                    marginLeft: '21px'
                }}
            >
                <Box
                    sx={{
                        marginLeft: '-21px'
                    }}
                >
                    {texts.map((text, index) => (
                        <> {index !== len - 1 && <QueueCard id={id} tweet={text} dateTimeMS={dateTimeMS} status={status} index={index} texts={texts} setTriggerQueueFetch={setTriggerQueueFetch} />}</>
                    ))}
                    {/* <QueueCard />
                    <QueueCard /> */}
                </Box>
            </Box>
            <QueueCard id={id} index={len - 1} tweet={texts[len - 1]} dateTimeMS={dateTimeMS} status={status} texts={texts} setTriggerQueueFetch={setTriggerQueueFetch} />
        </Box>
    );
};

export default ThreadCard;
